import usaEmployee from "../../pages/addUsaEmployee/usaEmployee.json";
import { createSlice } from "@reduxjs/toolkit";

// Single source of truth for document fields that hold multiple files.
// Keep this in sync wherever documents are rendered (e.g. usaDocuments.js).
export const MULTI_DOC_FIELDS = [
  "offerLetterV1",
  "agreementLetterV1",
  "f1VisaDocumentsV1",
  "employmentDocument",
  "h1BDocuments",
  "opt",
  "ead",
  "i20Form",
  "educationalDocuments",
];

export const normalizeDocuments = (documents) => {
  if (!documents || typeof documents !== "object") {
    documents = {};
  }
  const normalized = { ...documents };
  for (const field of MULTI_DOC_FIELDS) {
    const value = normalized[field];
    if (Array.isArray(value)) {
      // Drop empty placeholder entries (objects with no file name).
      normalized[field] = value.filter((f) => f && f.name);
    } else if (value && typeof value === "object" && value.name) {
      // A single real document object -> wrap in an array.
      normalized[field] = [value];
    } else {
      // Placeholder object, string, null, undefined, etc.
      normalized[field] = [];
    }
  }
  return normalized;
};

const normalizeEmployee = (employee) => {
  if (!employee || typeof employee !== "object") return employee;
  return {
    ...employee,
    documents: normalizeDocuments(employee.documents),
  };
};

const initialState = {
  intialUsEmployee: normalizeEmployee(usaEmployee),
  feildsDisabled: false,
  inviteEmployeeMetaData: {},
};

export const usaEmployeeSlice = createSlice({
  name: "usaEmployee",
  initialState,
  reducers: {
    updatePersonalDetails: (state, action) => {
      const { name, value } = action.payload;
      state.intialUsEmployee.personalDetails[name] = value;
    },
    updateDetails: (state, action) => {
      const { name, value, directory } = action.payload;
      state.intialUsEmployee[directory][name] =
        typeof value === "string" ? value.trimStart() : value;
    },
    updateEmployeeWorkExperience: (state, action) => {
      const { value, path, index } = action.payload;
      state.intialUsEmployee.workExperience[index][path] = value;
    },
    updateEmployeeDetails: (state, action) => {
      const { value, path } = action.payload;
      const pathSegments = path.split(".");
      for (const pathSegment of pathSegments) {
        if (pathSegment === pathSegments[pathSegments.length - 1]) {
          state.intialUsEmployee[pathSegment] = value;
        } else {
          state.intialUsEmployee = state[pathSegment];
        }
      }
      //state.employeeDetails["name"]=action.payload;
    },
    addWorkExperience: (state, action) => {
      let workExperience = {
        companyName: "",
        designation: "",
        startDate: "",
        endDate: "",
        documents: [],
      };
      state.intialUsEmployee.workExperience.push(workExperience);
    },
    updateUSAEmployeeJson: (state, action) => {
      const temp = action.payload;
      state.intialUsEmployee = normalizeEmployee(temp);
    },
    documentsMandatory: (state, action) => {
      const temp = action.payload;
      state.intialUsEmployee.documents = normalizeDocuments(temp);
    },
    setImmigrationDocumentsList: (state, action) => {
      const temp = action.payload;
      state.intialUsEmployee.immigrationDocumentsList = temp;
      console.log(temp, "immigrationDocumentsList");
    },
    updateInviteMetaData: (state, action) => {
      state.inviteEmployeeMetaData = action.payload;
    },
    resetState: (state) => {
      state.intialUsEmployee = normalizeEmployee(
        JSON.parse(JSON.stringify(usaEmployee))
      );
      state.feildsDisabled = false;
      state.inviteEmployeeMetaData = {};
    },
    feildsDisabled: (state, action) => {
      console.log(action.payload, "filedDisabled");
      state.feildsDisabled = action.payload;
    },
  },
});

export const {
  addEmployee,
  removeEmployee,
  updateEmployeeDetails,
  updateEmployeeWorkExperience,
  addWorkExperience,
  updateUSAEmployeeJson,
} = usaEmployeeSlice.actions;
export default usaEmployeeSlice.reducer;
